import React, { useState } from "react";
import {
    Box,
    Typography,
    TextField,
    Container,
} from "@mui/material";
import { CustomButton } from "../../utils/CustomTagComponents";
import { motion } from "framer-motion";
import { useInView } from "react-intersection-observer";
import { submitSubscribe } from "../../services/ContactFormService";
import { showToast } from "./Toast";

const Subscribe = () => {
    const [email, setEmail] = useState("");
    const [error, setError] = useState("");
    const [loading, setLoading] = useState(false);

    const validateEmail = () => {
        if (!email.trim()) {
            setError("Email is required");
            return false;
        }

        const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

        if (!emailRegex.test(email)) {
            setError("Enter a valid email");
            return false;
        }

        setError("");
        return true;
    };

    const handleSubscribe = async () => {
        if (!validateEmail()) return;

        try {
            setLoading(true);

            const payload = {
                email: email,
            };

            const res = await submitSubscribe(payload);

            if (res?.data?.success) {
                setEmail("");
                setError("");
                showToast("Subscribed successfully ✅");
            } else {
                showToast("Something went wrong ❌");
            }
        } catch (err) {
            console.error(err);
            showToast("Error while subscribing ❌");
        } finally {
            setLoading(false);
        }
    };
    const [ref, inView] = useInView({
        triggerOnce: true,
        threshold: 0.2,
    });

    const containerVariant = {
        hidden: { opacity: 0, y: 60 },
        visible: {
            opacity: 1,
            y: 0,
            transition: {
                duration: 0.6,
                staggerChildren: 0.2,
            },
        },
    };

    const itemVariant = {
        hidden: { opacity: 0, y: 30 },
        visible: {
            opacity: 1,
            y: 0,
            transition: { duration: 0.4 },
        },
    };
    return (
        <Container
            sx={{
                py: { xs: 2, sm: 2, md: 3 },
                px: { xs: 3, sm: 4, md: 6 },
                paddingLeft: { xs: "24px !important", md: "48px !important" },
                paddingRight: { xs: "24px !important", md: "48px !important" },
            }}
        >
            <Box
                component={motion.div}
                ref={ref}
                variants={containerVariant}
                initial="hidden"
                animate={inView ? "visible" : "hidden"}
                maxWidth="lg"
                sx={{
                    background: "#002045",
                    borderRadius: "20px",
                    padding: { xs: "20px 25px", md: "40px 60px" },
                    textAlign: "center",
                    position: "relative",
                    margin: '0 auto'
                }}
            >
                {/* Title */}
                <motion.div variants={itemVariant}>
                    <Typography
                        sx={{
                            color: "#fff",
                            fontSize: { xs: 22, md: 30 },
                            fontWeight: 700,
                            // mb: { xs: 1, md: 2 },
                            // letterSpacing:"0.89px"
                        }}
                    >
                        Subscribe Newsletters
                    </Typography>
                </motion.div>
                <motion.div variants={itemVariant}>
                    {/* Description */}
                    <Typography
                        sx={{
                            color: "rgba(255,255,255,0.7)",
                            fontSize: { xs: 14, md: 16 },
                            maxWidth: "520px",
                            margin: "0 auto",
                            marginBottom:4
                        }}
                    >
                        Stay updated with the latest news, updates and insights from
                        Glapsol. Our newsletter keeps you informed every week.
                    </Typography>
                </motion.div>

                {/* Email Input */}
                <motion.div variants={itemVariant}>
                    <Box sx={{ maxWidth: "520px", margin: "0 auto", mt: 1 }}>

                        {/* Input Box */}
                        <Box
                            sx={{
                                background: "#fff",
                                borderRadius: "50px",
                                display: "flex",
                                alignItems: "center",
                                p: "6px",
                                border: error ? "1px solid #ef4444" : "1px solid transparent", // 🔴 highlight
                            }}
                        >
                            <TextField
                                value={email}
                                onChange={(e) => {
                                    setEmail(e.target.value);
                                    setError("");
                                }}
                                placeholder="Enter your email address"
                                variant="standard"
                                fullWidth
                                InputProps={{
                                    disableUnderline: true,
                                }}
                                sx={{
                                    px: 3,
                                    "& input": {
                                        fontSize: 16,
                                        py: 1.5,
                                    },
                                }}
                            />

                            <CustomButton
                                onClick={handleSubscribe}
                                disabled={loading}
                                variant="contained"
                                sx={{
                                    borderRadius: "40px !important",
                                    px: "48px !important",
                                    // py: "12px !important",
                                    // fontSize: { xs: "13px !important", md: "15px !important" },
                                    whiteSpace: "nowrap",
                                }}
                            >
                                {loading ? "Submitting..." : "Subscribe Now"}
                            </CustomButton>
                        </Box>

                        {/* 🔴 Error Message BELOW */}
                        {error && (
                            <Typography
                                sx={{
                                    color: "red",
                                    fontSize: "14px",
                                    mt: 1,
                                    ml: 2,
                                }}
                            >
                                {error}
                            </Typography>
                        )}
                    </Box>
                </motion.div>
            </Box>
        </Container>
    );
};

export default Subscribe;